import { Flex, Text } from '@shared/components';

export interface QSetReviewResultOverviewCardProps {
  title: string;
  description: string;
  variant?: 'secondary' | 'success' | 'error' | 'info' | 'warning';
}

const variantStyles = {
  secondary: {
    backgroundColor: 'grey.100',
    color: 'text.primary',
  },
  success: {
    backgroundColor: 'success.lighter',
    color: 'success.main',
  },
  error: {
    backgroundColor: 'error.lighter',
    color: 'error.main',
  },
  info: {
    backgroundColor: 'info.lighter',
    color: 'info.main',
  },
  warning: {
    backgroundColor: 'warning.lighter',
    color: 'warning.main',
  },
};

export default function QSetReviewResultOverviewCard(props: QSetReviewResultOverviewCardProps) {
  const { title, description, variant = 'secondary' } = props;
  const styles = variantStyles[variant];
  return (
    <Flex
      sx={(theme) => ({
        ...styles,
        flexDirection: 'column',
        padding: theme.spacing(4),
        borderRadius: theme.shape.rounded(2),
        gap: theme.spacing(1),
        width: '100%',
      })}
    >
      <Text>{title}</Text>
      <Text variant='h3'>{description}</Text>
    </Flex>
  );
}
